








































































































































import { Component, Vue } from 'vue-property-decorator';
import { OrderPriority, OrderStatus } from '@/interfaces/order.interface';
import { namespace } from 'vuex-class';
import { User, UserGroup } from "@/interfaces/user.interface";

const ordersModule = namespace('orders');
const usersModule = namespace('users');

@Component
export default class OrderFilters extends Vue {
  @ordersModule.Action setOrdersFilter: any;
  @ordersModule.State statuses: OrderStatus[];
  @ordersModule.State priorities: OrderPriority[];
  @ordersModule.Action fetchOrders!: any;
  @usersModule.State users: User[];
  @usersModule.State groups: UserGroup[];

  searchTimer: number;

  clearCreatedAtRange(): void {
    this.setOrdersFilter({ createdAtRange: [] });
    this.startSearchCountdown();
  }

  get formattedCreatedAtRange() {
    return this.createdAtRangeFilter.join(' - ');
  }

  get search(): string {
    return this.$store.state.orders.orderFilters.search;
  }

  set search(search: string) {
    this.setOrdersFilter({search});
  }

  get shipperCountryName(): string {
    return this.$store.state.orders.orderFilters.shipperCountryName;
  }

  set shipperCountryName(shipperCountryName: string) {
    this.setOrdersFilter({shipperCountryName});
  }

  get consigneeCountryName(): string {
    return this.$store.state.orders.orderFilters.consigneeCountryName;
  }

  set consigneeCountryName(consigneeCountryName: string) {
    this.setOrdersFilter({consigneeCountryName});
  }

  get statusFilter() {
    return this.$store.state.orders.orderFilters.status;
  }

  set statusFilter(value: string[]) {
    this.setOrdersFilter({status: value});
  }

  get priorityFilter() {
    return this.$store.state.orders.orderFilters.priority;
  }

  set priorityFilter(value: string[]) {
    this.setOrdersFilter({priority: value});
  }

  get shipperGroupFilter() {
    return this.$store.state.orders.orderFilters.shipperGroup;
  }

  set shipperGroupFilter(value: string[]) {
    this.setOrdersFilter({shipperGroup: value});
  }

  get logisticsFilter() {
    return this.$store.state.orders.orderFilters.logistics;
  }

  set logisticsFilter(value: string[]) {
    this.setOrdersFilter({logistics: value});
  }

  get createdAtRangeFilter() {
    return this.$store.state.orders.orderFilters.createdAtRange;
  }

  set createdAtRangeFilter(value: string[]) {
    this.setOrdersFilter({createdAtRange: value});
  }

  startSearchCountdown() {
    if (this.searchTimer) clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(() => {
      this.fetchOrders();
    }, 300);
  }
}
